import React from "react"
import styled from "styled-components"
import get from "lodash/get"
import { translate } from "react-i18next"

import isEmpty from "lodash/isEmpty"
import Tab, { TabPanel } from "../components/tabPanel"
import Auctions from "./Auctions"
import BuyBids from "./BuyBids"
import PastWinners from "./PastWinners"
import AllBids from "./AllBids"
import MyAccount from "./MyAccount"
import config from "../Config"
import Storage from "../util/Storage"
import Cookie from "../util/Cookie"
import i18n from "../i18n"
import { fetchData, removeData, showPopup } from "../store/action"
import { connect } from "react-redux"

const HomeContainer = styled.div`
  height: calc(100% - 56px);
  overflow: hidden;
`

// const TabsConfig = [
//     { label: "BID", component: <Auctions/>, selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_auctions_red.svg`, unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_auctions.svg`},
//     { label: "BuyBids", component: <BuyBids/>, selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_buy_bids_red.svg`, unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_buy_bids.svg`},
//     { label: "Winners", component: <PastWinners/>, selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_winners_red.svg`, unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_winners.svg`},
//     { label: "MyAccount", component: <MyAccount/>, selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_account_red.svg`, unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_profile.svg`},
// ];

// const TabsConfig = [
//   {
//     label: "Home",
//     component: <Auctions />,
//     // selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_auctions_red.svg`,
//     // unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_auctions.svg`,
//     selectedIconUrl: `${
//       config.BIDNWIN_S3_IMAGE_URL_NEW_UI
//     }/other-icons/home-tab.png`,
//     unSelectedIconUrl: `${
//       config.BIDNWIN_S3_IMAGE_URL_NEW_UI
//     }/other-icons/home-tab.png`,
//   },
//   {
//     label: "BID",
//     component: <AllBids />,
//     selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_winners_red.svg`,
//     unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_winners.svg`,
//   },
//   {
//     label: "BuyBid",
//     component: <BuyBids />,
//     // selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_buy_bids_red.svg`,
//     // unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_buy_bids.svg`,
//     selectedIconUrl: `${
//       config.BIDNWIN_S3_IMAGE_URL_NEW_UI
//     }/other-icons/buy-bid-tab.png`,
//     unSelectedIconUrl: `${
//       config.BIDNWIN_S3_IMAGE_URL_NEW_UI
//     }/other-icons/buy-bid-tab.png`,
//   },
// ]

// const SubscribedTabsConfig = [
//   {
//     label: "BID",
//     component: <Auctions />,
//     selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_auctions_red.svg`,
//     unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_auctions.svg`,
//   },
//   {
//     label: "Winners",
//     component: <PastWinners />,
//     selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_winners_red.svg`,
//     unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_winners.svg`,
//   },
//   {
//     label: "MyAccount",
//     component: <MyAccount />,
//     selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_account_red.svg`,
//     unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_profile.svg`,
//   },
// ]

class Home extends React.Component {
  componentDidMount() {
    console.log("props", this.props)
  }

  TabsConfig = [
    {
      label: "Home",
      component: <Auctions />,
      // selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_auctions_red.svg`,
      // unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_auctions.svg`,
      selectedIconUrl:
        this.props.theme.navIcons && this.props.theme.navIcons.home,
      unSelectedIconUrl:
        this.props.theme.navIcons && this.props.theme.navIcons.home,
    },
    {
      label: "BID",
      component: <AllBids />,
      selectedIconUrl: `${
        config.MRBIDNWIN_S3_IMAGE_URL
      }/ic_tab_winners_red.svg`,
      unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_winners.svg`,
    },
    {
      label: "BuyBid",
      component: <BuyBids />,
      // selectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_buy_bids_red.svg`,
      // unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_buy_bids.svg`,
      selectedIconUrl:
        this.props.theme.navIcons && this.props.theme.navIcons.buyBid,
      unSelectedIconUrl:
        this.props.theme.navIcons && this.props.theme.navIcons.buyBid,
    },
  ]

  SubscribedTabsConfig = [
    {
      label: "BID",
      component: <Auctions />,
      selectedIconUrl: `${
        config.MRBIDNWIN_S3_IMAGE_URL
      }/ic_tab_auctions_red.svg`,
      unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_auctions.svg`,
    },
    {
      label: "Winners",
      component: <PastWinners />,
      selectedIconUrl: `${
        config.MRBIDNWIN_S3_IMAGE_URL
      }/ic_tab_winners_red.svg`,
      unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_winners.svg`,
    },
    {
      label: "MyAccount",
      component: <MyAccount />,
      selectedIconUrl: `${
        config.MRBIDNWIN_S3_IMAGE_URL
      }/ic_tab_account_red.svg`,
      unSelectedIconUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_tab_profile.svg`,
    },
  ]

  componentWillMount() {
    const { i18n } = this.props
    const locale = Cookie.get("X-Reycreo-Language-Id")
    const newUser = Cookie.get("newUser")
    const localData = Storage.get("newUser")
    i18n.changeLanguage(locale || "en")

    console.log("Home WIll MOunt")
    if (newUser && (!localData || (localData && localData === "true"))) {
      Storage.set("newUser", newUser || "false")
    }
    // console.log("home", this.props)
    console.log("pathname", this.props.location.pathname)
    if (this.props.location.pathname === "/play/campaign") {
      this.props.showPopup({
        renderComponent: () => (
          <iframe
            width='400px'
            height='350px'
            scrolling='no'
            src='http://mgh.mybidwin.com/vsbidwin/index.php'
            sandbox='allow-modals allow-forms allow-popups allow-scripts allow-same-origin'
          />
        ),
        showPopup: true,
        // style: {
        //   width: "75%",
        //   height: "auto",
        //   minHeight: "400px",
        // },
      })
    }
  }

  componentWillUpdate() {
    console.log("Component WIll Update Home")
  }

  render() {
    console.log("props", this.props)
    // console.log("Home props -->>",this.props)
    let host = window.location.hostname
    let subDomain = host.split(".")[0]
    let subStatus = Cookie.get("SubscriberStatus")
    console.log(subDomain, " Home ", subStatus)

    let flagBuy = "false"
    if (subDomain === "epu" && subStatus === "SUBSCRIBED") {
      flagBuy = "true"
    }
    if (!subStatus) {
      subStatus = "TRIAL"
    }

    console.log("Home props -->>", flagBuy)
    if (flagBuy === "true") {
      return (
        <HomeContainer>
          <TabPanel
            theme={this.props.theme}
            selectedIndex={get(this.props, "location.state.selectedIndex")}
          >
            {this.SubscribedTabsConfig.map((el, index) => {
              return (
                <Tab
                  key={index}
                  tabsData={el}
                  style={{ height: 55 }}
                  label={el.label}
                  theme={this.props.theme}
                >
                  {el.component}
                </Tab>
              )
            })}
          </TabPanel>
        </HomeContainer>
      )
    } else {
      return (
        <HomeContainer>
          <TabPanel
            theme={this.props.theme}
            selectedIndex={get(this.props, "location.state.selectedIndex")}
          >
            {this.TabsConfig.map((el, index) => {
              return (
                <Tab
                  key={index}
                  tabsData={el}
                  style={{ height: 55 }}
                  label={el.label}
                  theme={this.props.theme}
                >
                  {el.component}
                </Tab>
              )
            })}
          </TabPanel>
        </HomeContainer>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showPopup: (obj) => dispatch(showPopup(obj)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(Home))



// WEBPACK FOOTER //
// ./src/views/Home.js